import React from 'react';
import EventCard from 'components/molecules/event-card/EventCard';

function SeaMeeting() {
  const dateTexts = ['1899年', 'x月'];
  const title = 'S.E.A.会合';
  const imgUrl = 'https://seadictionary.disneyparkstory.com/wp-content/uploads/sites/2/2016/09/CiOPjj3UUAArasV-300x242.jpg'
  const description = (
    <>
      {'当時の主要S.E.A.メンバーたちが一同に会する。'}
      {'有名なこの絵画に写っているのは、左から'}
      <a href='/harrison-hightower-iii'>
        {'ハリソンハイタワー三世'}
      </a>
      {'、'}
      <a href='/r-blauerhimmel'>
        {'R.ブラウアーヒンメル'}
      </a>
      {'、'}
      <a href='/henry-mystic'>
        {'ヘンリーミスティック卿'}
      </a>
      {'、'}
      <a href='/j-l-baterista'>
        {'J.L.バティリスタ博士'}
      </a>
      {'、'}
      <a href='/barnabas-t-bullion'>
        {'バーナバス T.ブリオン'}
      </a>
      {'、'}
      <a href='/snowsuit'>
        {'防寒着の男（名前不明）'}
      </a>
      {'、'}
      <a href='/mary-oceaneer'>
        {'メアリーオーシャニア船長'}
      </a>
      {'、'}
      <a href='/charlton-j-taboret'>
        {'チャールトン J.タバレット'}
      </a>
      {'である。'}
    </>
  );


  return (
    <EventCard
      dateTexts={dateTexts}
      title={title}
      description={description}
      imgUrl={imgUrl}
      important
    />
  );
}

export default SeaMeeting;
